const dateField = (editor) => {

    editor.BlockManager.add('date-field', {
        label: `
            <i class="far fa-calendar-alt"></i>
            <div class="gjs-fontFamily gjs-block-label">Date field</div>
        `,
        category: 'Forms ',
        content: `  <div class="form-group d-flex flex-column">
                      <label for="date" class="col-form-label p-2 font-weight-bold" >Date</label>
                      <div class="input-group date" id="datepicker">
                        <input type="text" class="form-control" id="date"/>
                        <span class="input-group-append">
                          <span class="input-group-text bg-light d-block">
                            <i class="fa fa-calendar"></i>
                          </span>
                        </span>
                      </div>
                    </div>
                        `,
        attributes: {},
    });

}

export default dateField;